import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useVenue } from '../../hooks/useVenue'
import { deleteVenue } from '../../services/api/deleteVenue'
import { ConfirmDeleteEntityPage } from '../ConfirmDeleteEntityPage/ConfirmDeleteEntityPage'

export function VenueDeletePage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()
  const { venue, isLoading, error } = useVenue(id ?? '')

  async function handleConfirm() {
    await deleteVenue(await getToken(), id!)
    navigate('/venues')
  }

  return (
    <ConfirmDeleteEntityPage
      entityLabel="Venue"
      title={venue?.name ?? ''}
      cancelTo={`/venues/${id}`}
      onConfirm={handleConfirm}
      isLoading={isLoading}
      loadError={error}
    />
  )
}
